<template>
  <Modal v-model="visible" :mask-closable="false" :closable="progress==100 || title.indexOf('失败') != -1" :footer-hide="true" width="550">
    <div class="modal-loading">
      <div class="circleProgress_wrapper">
        <div class="num">{{progress}}%</div>
        <div class="wrapper right">
            <div class="circleProgress rightcircle" :style="rightDeg"></div>
        </div>
        <div class="wrapper left">
            <div class="circleProgress leftcircle" :style="leftDeg"></div>
        </div>
      </div>
      <div class="title-text" v-if="progress!=100">{{title}}</div>
      <div class="title-text" v-else>完成！</div>
      <div class="info-text" v-html="content"></div>
      <div class="info-desc">{{ descText }}</div>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      size: 2,
      title:"",
      content:"",
      descText:"",
      visible:false,//显示
      progress:100,
    };
  },
  
  computed:{
    rightDeg(){
      if(this.progress>=50){
        return {transform: "rotate(225deg)"};
      }else{
        return {transform: "rotate("+((225-45)/50*this.progress+45)+"deg)"};
      }
    },
    leftDeg(){
      if(this.progress<=50){
        return {transform: "rotate(45deg)"};
      }else{
        return {transform: "rotate("+((225-45)/50*(this.progress-50)+45)+"deg)"};
      }
    }
  },
  
  methods:{
    setText(data){
      if(data.title){
        this.title = data.title;
      }
      if(data.size){
        this.size = data.size;
      }
      if(data.content){
        this.content = data.content;
      }
      if(data.progress){
        this.progress = data.progress;
      }
      if(data.descText){
        this.descText = data.descText;
      }
    },
    close(){
      this.visible = false;
    },
    open(data){
      this.visible = true;
      this.progress=0;
      this.autoPlay();
      this.setText(data);
    },
    autoPlay(){
      const size = this.size;
      setTimeout(()=>{
        if(this.visible == false||this.progress>=99){
          return;
        }
        if(this.progress+size>99){
          this.progress = 99;
          return;
        }
        this.progress=this.progress+size;
        this.autoPlay();
      }, 100)
    },
    ok(){
      this.progress = 100;
    }
  },
};
</script>
<style lang="scss">
@import "./modalLoading.scss";
</style>